import { Box } from "@mui/material";
import { Header } from "../components/common";

function PageLayout({ children, sx }) {
  return (
    <Box
      sx={{
        bgcolor: "#EEF7FF",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <Header />
      <Box sx={{ py: "30px" }}>
        <Box
          sx={{
            width: { xs: "92%", sm: "90%", md: "70%", lg: "50%" },
            height: "100%",
            px: { xs: "15px", sm: "50px", md: "50px" },
            py: { xs: "30px", md: "50px" },
            bgcolor: "#FFFFFF",
            margin: " auto",
            borderRadius: 2,
            ...sx,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default PageLayout;
